<script setup lang="ts">
import AppTooltip from '@/components/AppTooltip.vue'
import { formatDateTime, timeAgo } from '@/lib/utils'

const props = defineProps<{ date: string }>()
</script>

<template>
  <AppTooltip :content="formatDateTime(props.date)" side="top">
    <span class="cursor-default">{{ timeAgo(props.date) }}</span>
  </AppTooltip>
</template>
